export const data = {
  title: 'Create new company',
  subtitle: "In order to add a product you need to add your Company and go through a quick KYB procedure."
}